<div class="login-page-wrapper">
    <h1 class="main-heading">TCA Login</h1>
    <div class="alert alert-info py-2 text-center" role="status"><strong>Demo mode</strong> — credentials are pre-filled; use OTP <strong>1234</strong>.</div>
    <p class="description-text d-none">The AUC TCA application to be fully completed, signed and stamped by an authorized signatory at the TCA end, with no missing data.</p>
    
    <form [formGroup]="loginForm" (ngSubmit)="onSubmitForm($event)" class="form-container">
        <div class="fields-container">
            <div class="mb-3 email-section">
                <label for="email" class="email-label form-label font-weight-bold">Email</label>
                <input type="email" class="email-inpute form-control" id="email" formControlName="Email"
                    placeholder="Enter your Email">
                <div *ngIf="loginForm.get('Email')?.invalid && (loginForm.get('Email')?.dirty || loginForm.get('Email')?.touched)"
                    class="text-danger">
                    <small *ngIf="loginForm.get('Email')?.errors?.['required']">Email is required.</small>
                    <small *ngIf="loginForm.get('Email')?.errors?.['email']">Enter a valid email.</small>
                    <small *ngIf="loginForm.get('Email')?.errors?.['custom']">{{ loginForm.get('Email')?.errors?.['custom']
                        }}</small>
                </div>
            </div>
            <div class="mb-3 password-section">
                <label for="password" class="password-label form-label">Password</label>
                <div class="password-input-wrapper">
                    <input [type]="showPassword ? 'text' : 'password'" class="password-inpute form-control" id="password"
                        formControlName="Password" placeholder="Enter your Password">
                    <i class="fas password-toggle-icon" 
                       [class.fa-eye]="!showPassword" 
                       [class.fa-eye-slash]="showPassword"
                       [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
                       (click)="togglePasswordVisibility()"
                       role="button"
                       tabindex="0"
                       (keydown.enter)="togglePasswordVisibility()"
                       (keydown.space)="togglePasswordVisibility()"></i>
                </div>
                <div *ngIf="loginForm.get('Password')?.invalid && (loginForm.get('Password')?.dirty || loginForm.get('Password')?.touched)"
                    class="text-danger">
                    <small *ngIf="loginForm.get('Password')?.errors?.['required']">Password is required.</small>
                    <small *ngIf="loginForm.get('Password')?.errors?.['minlength']">Password must be at least 6 characters
                        long.</small>
                    <small *ngIf="loginForm.get('Password')?.errors?.['custom']">{{
                        loginForm.get('Password')?.errors?.['custom'] }}</small>
                </div>
            </div>
            <div class="submition d-flex justify-content-center">
                <button type="submit" class="submit-btn btn btn-primary">Sign In</button>
            </div>

            <div class="mt-3 d-flex justify-content-center d-none">
                <button type="button" class="submit-btn btn btn-outline-secondary d-flex align-items-center gap-2"
                    (click)="loginWithMicrosoft()" [disabled]="isMicrosoftLoading">
                    <span class="microsoft-icon" aria-hidden="true"><span></span><span></span><span></span><span></span></span>
                    <span>{{ isMicrosoftLoading ? 'Signing in...' : 'Sign in with Microsoft' }}</span>
                </button>
            </div>

            <div class="forgot-password mt-3 d-flex justify-content-center">
                <a [routerLink]="['/', AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.FORGET_EMAIL]"
                    class="forgot-password-link text-decoration-none">Forget Password?</a>
            </div>
        </div>
    </form>
</div>
